import React, { useState, useEffect } from "react";
import Card from "./Card";
import useRequest from "../../../context/useRequest";
// import { useNavigate } from "react-router-dom";
const OffersCardDetails = () => {
    const { sendRequest } = useRequest(); 
    const [offersDetails, setOffersDetails] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    // const navigate = useNavigate();
    useEffect(() => {
        const fetchOffers = async () => {
            try {
                const response = await sendRequest({
                    method: "GET",
                    url: "/promoCode", 
                });

                if (response && response.data) {
                    setOffersDetails(response.data);

                    
                }
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchOffers();
    }, [sendRequest]);

    if (loading) {
        return <p>Loading offers...</p>;
    }

    if (error) {
        return <p className="text-center error">{error}</p>;
    }
    
    
    return (
        <>
            {offersDetails.length > 0 ? (
                offersDetails.map((card, index) => (
                    <Card
                        key={index}
                        image={card.image}
                        title={card.promo_code_name}
                        superOffer={card.promo_description}
                        minimum={card.minimum_value}
                        amount={card.discount_amount} 
                        
                        discount_type={card.discount_type === "flat" ? "₹" : "%"}
                        customClass="col-12 col-lg-6 mb-4"
                        parentClass="destinations-section"
                        card="card"
                        cardBody="card-body"
                    />
                ))
            ) : (
                <p className="text-center error">No offers available at the moment.</p>
            )}
        </>
    );
};

export default OffersCardDetails;
